import { Component, OnInit, Input, Output, EventEmitter, HostBinding, HostListener } from '@angular/core';

export type ButtonType = 'primary' | 'secondary' | 'cancel' | 'back' | 'back-mini' | 'secondary';

@Component({
    selector: 'viega-button',
    templateUrl: './viega-button.component.html',
    styleUrls: ['./viega-button.component.scss'],
})
export class ViegaButtonComponent {
    private static readonly TypeToIconMap: { [buttonType: string]: string } = {
        'default': 'right',
        'secondary': '',
        'back': 'angle-left',
        'back-mini': 'angle-left',
        'cancel': 'close',
    };
    private static readonly TypeToIconLeftAlignMap: { [buttonType: string]: boolean } = {
        'back': true,
        'back-mini': true,
        'cancel': true,
    };

    public matColor: string = "primary";

    @Input()
    public enableIcon: boolean = true;

    @Input()
    public isDisabled: boolean = false;

    @HostBinding('attr.disabled')
    public get disabled(): string {
        return this.isDisabled ? 'disabled' : undefined;
    }

    @Input()
    public type: string = "default";

    private _icon: string;
    public get icon(): string {
        return this._icon;
    }

    @Input()
    public set icon(newValue: string) {
        this._icon = newValue;
    }

    public get internalIcon(): string {
        if (this._icon)
            return this._icon;
        else
            return ViegaButtonComponent.TypeToIconMap[this.type];
    }

    public get isRightAlignIcon(): boolean {
        return !ViegaButtonComponent.TypeToIconLeftAlignMap[this.type];
    }

    public click(event: MouseEvent) {
        if (this.isDisabled)
            event.stopImmediatePropagation();
    }
}



// WEBPACK FOOTER //
// ./src/viega-common/components/viega-button/viega-button.component.ts